module.exports = __webpack_public_path__ + "img/invest-activity-icon.png";